import { formValidation, klaviyo } from 'assets/utilities';

import './footer.scss';

const CLASSNAME_SUCCESS = 'footer__subscribe--success';
const SELECTOR_FORM = '.js-footerSubscribe';
const SELECTOR_FOOTER = '.js-footer';

const onNewsletterError = function onFooterNewsletterError(err) {
  const form = document.querySelector(SELECTOR_FORM);
  const message = err.message || '';
  const id = form.querySelector('input').getAttribute('id');

  const submit = form.querySelector('button');
  submit.disabled = false;

  submit.insertAdjacentHTML(
    'afterend',
    `<label aria-live="polite" class="form__error-msg" for="${id}">
      An error occurred${message ? ` - ${message}` : ''}
    </label>`,
  );
};

const onNewsletterResponse = function onFooterNewsletterResponse(response) {
  const form = document.querySelector(SELECTOR_FORM);
  const formSuccess = document.querySelector('.js-footerSubscribeSuccess');
  const hasError = response.data
    && response.data.errors
    && response.data.errors.length;

  if (!form) {
    return;
  }

  if (hasError) {
    onNewsletterError({ message: response.data.errors.join(' ') });
  } else {
    form.classList.add(CLASSNAME_SUCCESS);
    formSuccess.focus();
  }
};

const submitForm = function submitSignupForm(form) {
  const email = form.elements.EMAIL.value || '';
  const source = form.elements.SOURCE ? form.elements.SOURCE.value : 'Footer';
  const submit = form.querySelector('button');

  submit.disabled = true;
  klaviyo.subscribe({
    email,
    source,
  })
    .then(onNewsletterResponse)
    .catch(onNewsletterError);
};

const onFormSubmit = function onSignupFormSubmit(ev) {
  const elForm = ev.currentTarget;
  const isValid = formValidation.validate(elForm);
  ev.preventDefault();

  if (isValid) {
    submitForm(elForm);
  }
};

const show = function showFooter() {
  document.querySelector(SELECTOR_FOOTER).classList.remove('is-hidden');
};

const hide = function hideFooter() {
  document.querySelector(SELECTOR_FOOTER).classList.add('is-hidden');
};

const init = function initFooter() {
  const form = document.querySelector(SELECTOR_FORM);
  if (!form) {
    return;
  }
  form.addEventListener('submit', onFormSubmit);
  form.setAttribute('novalidate', 'true');
  formValidation.bindChange(form);
};

export default {
  hide,
  init,
  show,
};
